import { createVNode as _createVNode } from "vue";
/**
 * @author liaoyanhua
 * @fileoverview 参赛要求、比赛规则（赛事规则）- pc
 */

import { defineComponent, reactive, computed } from 'vue';
// config
import { entryRuleList, raceRulesList } from '@/config/information';
// assets
import scRuleUrl from "@/assets/img/pc/sc-rule-tile.png";
import entryReqUrl from "@/assets/img/pc/entry-req.png";
import entryRuleTitleUrl from "@/assets/img/pc/rule-title.png";
import _ from "lodash";
export default defineComponent({
  name: 'RaceRules',
  setup() {
    const state = reactive({
      ruleActive: 1
    });
    const ruleList = computed(() => {
      return _.find(raceRulesList, item => state.ruleActive === item.id).list;
    });
    function handleRuleActive(id) {
      state.ruleActive = id;
    }
    return () => {
      return _createVNode("div", {
        "class": "pc-explain pc-information"
      }, [_createVNode("div", {
        "class": "sc-rules"
      }, [_createVNode("img", {
        "class": "title",
        "src": scRuleUrl,
        "id": "entry-require"
      }, null), _createVNode("div", {
        "class": "sub-content-box"
      }, [_createVNode("img", {
        "class": "entry-require",
        "src": entryReqUrl
      }, null), _createVNode("div", {
        "class": "entry-content"
      }, [_createVNode("img", {
        "class": "bg",
        "src": require(`@/assets/img/pc/entry-bg.png`),
        "style": "height: 750px;"
      }, null), _createVNode("div", {
        "class": "entry-content-inner scrollbar-class"
      }, [_.map(entryRuleList, (item, index) => {
        return _createVNode("div", {
          "class": "entry-rule-item",
          "innerHTML": item.contentText,
          "key": index
        }, null);
      })])])]), _createVNode("div", {
        "class": "sub-content-box",
        "id": "entry-rule"
      }, [_createVNode("img", {
        "class": "entry-require",
        "src": entryRuleTitleUrl,
        "style": "margin-top: 100px"
      }, null), _createVNode("div", {
        "class": "entry-content-rule"
      }, [_createVNode("div", {
        "class": "sub-btns"
      }, [_createVNode("img", {
        "class": "btn-img",
        "onClick": () => {
          handleRuleActive(1);
        },
        "src": require(`@/assets/img/pc/r-1${state.ruleActive === 1 ? "-actbtn" : "-btn"}.png`)
      }, null), _createVNode("img", {
        "class": "btn-img",
        "onClick": () => {
          handleRuleActive(2);
        },
        "src": require(`@/assets/img/pc/r-2${state.ruleActive === 2 ? "-actbtn" : "-btn"}.png`)
      }, null), _createVNode("img", {
        "class": "btn-img",
        "onClick": () => {
          handleRuleActive(3);
        },
        "src": require(`@/assets/img/pc/r-3${state.ruleActive === 3 ? "-actbtn" : "-btn"}.png`)
      }, null)]), _createVNode("img", {
        "class": "bg",
        "src": require(`@/assets/img/pc/rule-bg.png`),
        "style": "height: 600px"
      }, null), _createVNode("div", {
        "class": "content-inner",
        "style": "top: 90px"
      }, [_.map(ruleList.value, (item, index) => {
        return _createVNode("div", {
          "class": "entry-rule-item",
          "innerHTML": item.contentText,
          "key": index
        }, null);
      })])])])])]);
    };
  }
});